import { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AdvancedSettingsEnum,
  settingTypeToString,
} from '../../containers/SettingsPage/types';
import { settingsOptionsSelectors } from '../../reducers/entitySettingsOptionsSlice';
import { useAppSelector } from '../../reducers/rootReducer';
import { compareArraysValues, updateSearchParams } from '../utils';

const FILTER_TITLE = 'advanced';

export function useAdvancedSettingsDraft() {
  const navigate = useNavigate();
  const committedAdvancedSettings = useAppSelector(
    settingsOptionsSelectors.selectAdvancedSettings,
  );
  const committed = useMemo(() => {
    // None shares the Engineering label with Engineer; keep a unique display list.
    const labels = committedAdvancedSettings
      .filter((setting) => setting !== AdvancedSettingsEnum.None)
      .map((setting) => settingTypeToString[setting]);

    return [...new Set(labels)];
  }, [committedAdvancedSettings]);
  const [draft, setDraft] = useState<string[]>([]);

  useEffect(() => {
    setDraft((currentDraft) =>
      compareArraysValues(currentDraft, committed) ? currentDraft : committed,
    );
  }, [committed]);

  const dirty = !compareArraysValues(committed, draft);

  const apply = useCallback(() => {
    if (compareArraysValues(committed, draft)) {
      return;
    }

    const rolesArr = {} as Record<AdvancedSettingsEnum, string>;

    Object.keys(settingTypeToString).forEach((role) => {
      if (draft.includes(settingTypeToString[role as AdvancedSettingsEnum])) {
        rolesArr[role as AdvancedSettingsEnum] =
          settingTypeToString[role as AdvancedSettingsEnum];
      }
    });

    updateSearchParams(
      FILTER_TITLE,
      Object.keys(rolesArr).join(','),
      false,
      navigate,
    );
  }, [committed, draft, navigate]);

  const discard = useCallback(() => {
    setDraft(committed);
  }, [committed]);

  return { draft, setDraft, dirty, apply, discard };
}

export default useAdvancedSettingsDraft;
